import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/atoms/card';
import { Input } from '@/components/atoms/input';
import { Textarea } from '@/components/atoms/textarea';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/molecules/form-field';
import type { ShippingRateFormData } from '../types/shipping-form.types';

interface ShippingRateBasicInfoProps {
  form: UseFormReturn<ShippingRateFormData>;
}

export function ShippingRateBasicInfo({ form }: ShippingRateBasicInfoProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('shipping.basicInfo', { defaultValue: 'Basic Information' })}</CardTitle>
        <CardDescription>
          {t('shipping.basicInfoDesc', { defaultValue: 'Provide basic information about this shipping rate.' })}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('shipping.rateName', { defaultValue: 'Rate Name' })} *</FormLabel>
              <FormControl>
                <Input
                  placeholder={t('shipping.rateNamePlaceholder', { defaultValue: 'e.g., Standard Delivery' })}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('shipping.rateDescription', { defaultValue: 'Description' })}</FormLabel>
              <FormControl>
                <Textarea
                  placeholder={t('shipping.rateDescPlaceholder', { defaultValue: 'Describe this shipping option...' })}
                  rows={3}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
